module.exports = __webpack_public_path__ + "img/ts12.249be179.png";